export type PlannedPageData = {
  slug: string;
  label: string;
  title: string;
  phase: 2 | 3;
  goal: string;
  audience: string;
  contents: { title: string; text: string }[];
  features: string[];
  kpi: string;
};

export const roadmap = [
  { phase: 1, name: 'Vitrine', status: 'En ligne', pages: ['Accueil'] },
  { phase: 2, name: 'Conversion', status: 'Prochaine étape', pages: ['Organisateurs', 'Formules', 'Contact'] },
  { phase: 3, name: 'Contenu & fans', status: 'Ensuite', pages: ['Concerts', 'Le groupe', 'Médias'] },
];

export const plannedPages: PlannedPageData[] = [
  {
    slug: 'organisateurs',
    label: 'Organisateurs',
    title: 'Espace organisateurs',
    phase: 2,
    goal: 'Transformer un programmateur curieux en demande de devis. C’est la page la plus rentable du site : elle répond aux questions concrètes avant même qu’on décroche le téléphone.',
    audience: 'Mairies, comités des fêtes, festivals, salles, CSE, particuliers.',
    contents: [
      { title: 'Parcours par type d’événement', text: 'Festival, municipal, salle, privé : un argumentaire et des exemples adaptés à chacun.' },
      { title: 'Références', text: 'Lieux et festivals déjà joués parmi les 200+ dates, avec photos de foule.' },
      { title: 'Fiche technique & rider', text: 'Besoins son, lumière, scène et loges, téléchargeables en PDF.' },
      { title: 'FAQ organisateur', text: 'Durée, montage, autonomie technique, déplacement, conditions.' },
    ],
    features: ['Demande de devis qualifiée en 3 étapes', 'Téléchargement du dossier de presse', 'Témoignages d’organisateurs'],
    kpi: 'Nombre de demandes de devis par mois',
  },
  {
    slug: 'formules',
    label: 'Formules',
    title: 'Formules & spectacles',
    phase: 2,
    goal: 'Aider l’organisateur à choisir le bon spectacle en un coup d’œil, et valoriser la formule Jean-Louis Aubert comme seconde offre.',
    audience: 'Programmateurs et organisateurs qui comparent les offres.',
    contents: [
      { title: 'Tribute Téléphone', text: 'Set list type, durée jusqu’à 1h30, extraits vidéo du show.' },
      { title: 'Formule Jean-Louis Aubert', text: 'Présentation du répertoire, extraits audio et vidéo.' },
      { title: 'Comparatif des formules', text: 'Durée, format, besoins techniques côte à côte.' },
    ],
    features: ['Lecteur d’extraits intégré', 'Tableau comparatif', 'Bouton « Demander cette formule » pré-rempli'],
    kpi: 'Clics vers le formulaire depuis chaque formule',
  },
  {
    slug: 'contact',
    label: 'Contact',
    title: 'Contact & booking',
    phase: 2,
    goal: 'Recevoir des demandes complètes et exploitables tout de suite : date, lieu, type d’événement, budget.',
    audience: 'Toute personne souhaitant booker le groupe ou le contacter.',
    contents: [
      { title: 'Formulaire de booking', text: 'Date, ville, type d’événement, jauge, formule souhaitée, message.' },
      { title: 'Coordonnées directes', text: 'Téléphone et e-mail du booking, pour les demandes urgentes.' },
      { title: 'Réseaux sociaux', text: 'Liens Facebook, Instagram et YouTube du groupe.' },
    ],
    features: ['Validation des champs et confirmation d’envoi', 'Protection anti-spam', 'E-mail récapitulatif automatique'],
    kpi: 'Taux de complétion du formulaire',
  },
  {
    slug: 'concerts',
    label: 'Concerts',
    title: 'Agenda des concerts',
    phase: 3,
    goal: 'Prouver que le groupe tourne en continu et donner aux fans une raison de revenir sur le site.',
    audience: 'Fans, public local et organisateurs qui vérifient l’activité.',
    contents: [
      { title: 'Prochaines dates', text: 'Ville, lieu, horaire et lien billetterie pour chaque concert.' },
      { title: 'Carte de France', text: 'Toutes les villes où le groupe a joué, d’un seul regard.' },
      { title: 'Archives', text: 'L’historique des 200+ dates depuis 2012.' },
    ],
    features: ['Carte interactive', 'Filtre par région', 'Ajout au calendrier'],
    kpi: 'Clics vers les billetteries',
  },
  {
    slug: 'groupe',
    label: 'Le groupe',
    title: 'Le groupe',
    phase: 3,
    goal: 'Raconter l’histoire de Téléphomme et mettre des visages sur la musique pour créer de l’attachement.',
    audience: 'Fans, presse et organisateurs.',
    contents: [
      { title: 'L’histoire depuis 2012', text: 'Une frise chronologique animée des moments marquants.' },
      { title: 'Portraits des musiciens', text: 'Julien Bonnemain, Morgan Denys, Jeremy Gilson, Maximum Ravello.' },
      { title: 'Pourquoi Téléphone', text: 'Le rapport du groupe à l’héritage d’Aubert, Bertignac, Kolinka et Marienneau.' },
    ],
    features: ['Frise chronologique au scroll', 'Portraits HD', 'Citations des musiciens'],
    kpi: 'Temps passé sur la page',
  },
  {
    slug: 'medias',
    label: 'Médias',
    title: 'Médias & presse',
    phase: 3,
    goal: 'Centraliser vidéos, photos et articles pour convaincre en quelques secondes et faciliter le travail de la presse.',
    audience: 'Journalistes, programmateurs, fans.',
    contents: [
      { title: 'Vidéos live', text: 'Sélection de captations YouTube du groupe.' },
      { title: 'Galerie photos', text: 'Photos de scène et de foule, téléchargeables en HD.' },
      { title: 'Revue de presse', text: 'Articles et programmes culturels mentionnant le groupe.' },
    ],
    features: ['Galerie plein écran', 'Kit presse en un clic', 'Lecteur vidéo intégré'],
    kpi: 'Téléchargements du kit presse',
  },
];
